import React from "react"

import { CardWrapper } from "./styled"
import { H3 } from "../Heading/styled"
interface LookAheadCardsProps {
  title?: string
  to: string
}

export const LookAheadCards = ({
  title,
  to,
}: LookAheadCardsProps): JSX.Element => {
  return (
    <CardWrapper>
      <H3>{title}</H3>
      <a href={to}>Read Article</a>
    </CardWrapper>
  )
}
